module.exports = __webpack_public_path__ + "img/nolan-onedrive.b5ae0ffe.svg";